<script setup>
import { useSettingStore } from '@/store/SettingsStore';
import { useToast } from 'primevue/usetoast';
import InputSwitch from 'primevue/inputswitch';
import ArgonButton from '@/components/Argon/ArgonButton.vue';
import { computed, onMounted } from 'vue';

const settings = useSettingStore();
const toast = useToast();

onMounted(() => {
  settings.fetchUserSettings();
});

const metricUnits = computed({
  get: () => settings.units === 'metric',
  set: (isMetric) => {
    settings.units = isMetric ? 'metric' : 'imperial';
  },
});

const submitForm = async () => {
  try {
    // This assumes your store has an action to persist all settings at once
    // If not, you'd call updateSetting for each item.
    await settings.updateAllSettings();
    toast.add({severity: 'success', summary: 'Success', detail: 'Settings saved successfully!', life: 3000});
  } catch (error) {
    toast.add({severity: 'error', summary: 'Error', detail: 'Failed to save settings.', life: 3000});
  }
};
</script>

<template>
  <div class="card h-100">
    <div class="card-header pb-0">
      <h6 class="mb-0">Platform Settings</h6>
    </div>
    <div class="card-body p-3">
      <h6 class="text-uppercase text-body text-xs font-weight-bolder">Account</h6>
      <ul class="list-group">
        <li class="list-group-item border-0 px-0">
          <div class="d-flex align-items-center">
            <i class="fas fa-moon me-3"></i>
            <span class="text-sm">Dark Mode</span>
            <InputSwitch v-model="settings.darkMode" class="ms-auto"/>
          </div>
        </li>
        <li class="list-group-item border-0 px-0">
          <div class="d-flex align-items-center">
            <i class="fas fa-ruler-combined me-3"></i>
            <span class="text-sm">Use Metric Units</span>
            <InputSwitch v-model="metricUnits" class="ms-auto"/>
          </div>
        </li>
      </ul>
      <h6 class="text-uppercase text-body text-xs font-weight-bolder mt-4">Notifications</h6>
      <ul class="list-group">
        <li class="list-group-item border-0 px-0">
          <div class="d-flex align-items-center">
            <i class="fas fa-envelope me-3"></i>
            <span class="text-sm">Notify by Email</span>
            <InputSwitch v-model="settings.notifyByEmail" class="ms-auto"/>
          </div>
        </li>
        <li class="list-group-item border-0 px-0">
          <div class="d-flex align-items-center">
            <i class="fas fa-sms me-3"></i>
            <span class="text-sm">Notify by SMS</span>
            <InputSwitch v-model="settings.notifyBySMS" class="ms-auto"/>
          </div>
        </li>
        <li class="list-group-item border-0 px-0">
          <div class="d-flex align-items-center">
            <i class="fas fa-mobile-alt me-3"></i>
            <span class="text-sm">Notify by Push</span>
            <InputSwitch v-model="settings.notifyByPush" class="ms-auto"/>
          </div>
        </li>
      </ul>
    </div>
    <div class="card-footer text-end pt-0">
      <ArgonButton type="button" color="success" @click="submitForm">Save Changes</ArgonButton>
    </div>
  </div>
</template>
